import {safirIcon } from '../../utils/functions';

jQuery(function($) {
	$('<div class="toggle">'+safirIcon("theme-arrow")+'</div>').prependTo('.wp-block-safirtema-safirmenu.sidebar .menu-item-has-children');

	$(".wp-block-safirtema-safirmenu.sidebar .toggle, .wp-block-safirtema-safirmenu.sidebar .menu-item-has-children>a[href='#']").on("click", function(e) {
		e.preventDefault();
		var icon = $(this).closest("li").find(">.toggle");
		icon.toggleClass("active");
		icon.closest('li').find('>.sub-menu').slideToggle();
		if(!icon.hasClass("active")) {
			icon.closest('li').find('.sub-menu').slideUp();
			icon.closest('li').find('.toggle').removeClass("active");
		}
	});

	const currentMenuItem = $(".wp-block-safirtema-safirmenu .current-menu-item");
	currentMenuItem.find(">.sub-menu").slideDown();
	currentMenuItem.parents(".sub-menu").slideDown();
	currentMenuItem.parents("li").find(">.toggle").addClass("active");
	currentMenuItem.find(">.toggle").addClass("active");
});